import type { MemberStatus } from "shared/schema";
import { Icon } from "shared/react";
import { MEMBER_STATUS } from "shared/schema";

export function MemberStatusBadge({ status, mods = "" }: { status: MemberStatus | "none"; mods?: string | undefined }): React.ReactElement | null {
	return status === "blocked" ? (
		<span className={`badge badge-error ${mods}`}>
			<Icon icon="close" /> <span>{MEMBER_STATUS[status]}</span>
		</span>
	) : status === "invited" || status === "pending" ? (
		<span className={`badge ${mods}`}>
			<Icon icon="snooze" /> <span>{MEMBER_STATUS[status]}</span>
		</span>
	) : status !== "none" ? (
		<span className={`badge badge-success ${mods}`}>
			<Icon icon="tick" /> <span>{MEMBER_STATUS[status]}</span>
		</span>
	) : null;
}
